import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { server } from 'common/config';
import { PaymentData } from 'types/payment';

export const stringToDate = (str: string) => {
    const yr = str.substring(0, 4);
    const mo = str.substring(4, 6);
    const d = str.substring(6, 8);
    return {
        yr,
        mo,
        d
    };
};

export const paymentApi = createApi({
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    baseQuery: fetchBaseQuery({
        baseUrl: server.UAT_MAIN_DOMAIN,
        prepareHeaders: (headers) => {
            headers.set('X-API-KEY', server.UAT_PEGA_API);
            return headers;
        }
    }),
    endpoints: (build) => ({
        getInvoice: build.query<PaymentData, string>({
            query: (id) => ({
                url: `/api/IRISLicence/v1/GetLPFeeInvoiceData`,
                method: 'POST',
                body: {
                    licenceNumber: id
                }
            })
        })
    })
});
export const { useGetInvoiceQuery } = paymentApi;
